import { render, staticRenderFns } from "./not-found.html?vue&type=template&id=d85d3fd8&"
import script from "./not-found.js?vue&type=script&lang=js&"
export * from "./not-found.js?vue&type=script&lang=js&"
import style0 from "./not-found.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports